import React from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// Opens the native dialer on mobile via tel: link
export const CallButton = ({ number, label = "Call", variant = "success", size = "default", className, full }) => {
  if (!number) return null;
  return (
    <Button asChild variant={variant} size={size} className={cn(full && "w-full", className)}>
      <a href={`tel:${number}`}>
        <Phone className="h-4 w-4" /> {label}
      </a>
    </Button>
  );
};
